<template>
  <div v-if="showPop" class="AnswerWrongBookEntryGuide">
    <VanOverlay :show="showPop" z-index="999" lock-scroll @click="closeOverlay">
      <img
        class="but"
        :style="{ right: jiazhangsuo ? '2.187rem' : '0.387rem' }"
        src="https://img01.yzcdn.cn/upload_files/2021/10/27/FsEEYu1xDnjRJ-xhtT4y--67Q_tf.png"
      />
      <img
        class="point"
        :style="{ right: jiazhangsuo ? '1.787rem' : '0.787rem' }"
        src="https://img01.yzcdn.cn/upload_files/2021/10/27/FixksvuRV99a0bKCDEOXGe2OLefT.png"
      />
    </VanOverlay>
  </div>
</template>

<script>
/*
 * By Suxue
 * 2021/10/27
 */
import { Overlay } from 'vant'
import popRegister from '@/mixins/popRegister'
import { mapState } from 'vuex'
import { updateTreasureBox } from '@/api/user'

export default {
  name: 'AnswerWrongBookEntryGuide',
  components: {
    VanOverlay: Overlay
  },
  mixins: [popRegister],
  data() {
    return {
      popupName: 'AnswerWrongBookEntryGuide',
      keyName: 'WBGuide1',
      showPop: false,
      jiazhangsuo: false
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  mounted() {},
  methods: {
    openAction(opt) {
      const {
        userInfo: { treasureBox },
        keyName
      } = this
      const hasOpen = String(treasureBox).includes(keyName)
      if (hasOpen) {
        this.dealClose()
        return
      }
      console.log(opt)
      this.jiazhangsuo = opt.jiazhangsuo
      this.showPop = true
      document.querySelector('.bannerTop_icons_right').style.cssText = 'z-index: 99999'
      document.querySelector('.bannerTop_slot .wrongBookEntry').style.cssText =
        'position: relative; z-index: 99999'
    },
    closeOverlay() {
      this.close()
      updateTreasureBox({
        keyName: this.keyName
      })
      document.querySelector('.bannerTop_icons_right').style.cssText = 'z-index: 0'
      document.querySelector('.bannerTop_slot .wrongBookEntry').style.cssText = 'position: static'
      this.$pop.next()
    },
    closeAction() {
      this.showPop = false
    }
  }
}
</script>

<style lang="scss" scoped>
.AnswerWrongBookEntryGuide {
  position: relative;
  .but {
    position: absolute;
    top: 1px;
    right: 82px;
    width: 86px;
  }
  .point {
    position: absolute;
    top: 59px;
    right: 67px;
    width: 247px;
  }
}
</style>
